import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { EncrdecrService } from './../Auth/encrdecr.service';
import { ConvertToJSONService } from '../services/convert-to-json.service';
const headers = { headers: new HttpHeaders({ 'content-type': 'application/json' }) }
const headersnojson = { headers: new HttpHeaders({}) }

@Injectable({
  providedIn: 'root'
})
export class SGBBondServiceService {
  // ServerUrl ='http://localhost:4094/';// environment.ServerUrl;
  ServerUrl = environment.ServerUrl;
  constructor(private http: HttpClient,
    private EncrdecrService: EncrdecrService,
    private ConvertToJSON: ConvertToJSONService) { }

  PostDematDetails(formData: any): Observable<any> {
    const tokenOption = this.GetTokenNonJSON();
    let DataUrl = `${this.ServerUrl}/api/ClientSGBDematDetails/ClientSGBDematDetails`;
    return this.http.post<any>(DataUrl, formData, tokenOption);
  }

  GetClientSGBDemat(formData): Observable<any> {

    let DataUrl = `${this.ServerUrl}/api/ClientSGBDematDetails/GetClientSGBDematDetails`;
    const header = this.GetToken();
    let request = { data: this.EncrdecrService.setEncr(formData) }
    return this.http.post<any>(DataUrl, request, header).pipe();
  }

  GetClientSGBDematMaster(): Observable<any> {

    let DataUrl = `${this.ServerUrl}/api/SGBBond/GETSGBBondDetails`;
    const header = this.GetToken();
    return this.http.get<any>(DataUrl, header).pipe();
  }
  GetToken() {
    let token = sessionStorage.getItem('`huR,8@RK9^??b4 -.hfs!!uR,XX');
    let UserId = this.EncrdecrService.getDecr(sessionStorage.getItem('m5JkoXISmYRAIuY'));
    let User_Type = this.EncrdecrService.getDecr(sessionStorage.getItem('L2D3506kIHSk3E0'));
    let IpAddress = sessionStorage.getItem('Tgsh@#3734fjfskshh==');
    console.log('token::  ' + token + "@" + UserId + "|" + User_Type + "|" + IpAddress);
    const TOKEN = btoa(token + "@" + UserId + "|" + User_Type + "|" + IpAddress);
    const tokenOption = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'Authorization': `Basic ${TOKEN}`,
      })
    }
    return tokenOption;
  }
  GetTokenNonJSON() {
    let token = sessionStorage.getItem('`huR,8@RK9^??b4 -.hfs!!uR,XX');
    let UserId = this.EncrdecrService.getDecr(sessionStorage.getItem('m5JkoXISmYRAIuY'));
    let User_Type = this.EncrdecrService.getDecr(sessionStorage.getItem('L2D3506kIHSk3E0'));
    let IpAddress = sessionStorage.getItem('Tgsh@#3734fjfskshh==');
    const TOKEN = btoa(token + "@" + UserId + "|" + User_Type + "|" + IpAddress);
    const tokenOption = {
      headers: new HttpHeaders({
        'Authorization': `Basic ${TOKEN}`,
      })
    }
    return tokenOption;
  }
  PostDematPurchaseDetails(formData: any): Observable<any> {
    const tokenOption = this.GetTokenNonJSON();
    let DataUrl = `${this.ServerUrl}/api/SGBDematPurchase/PostSGBDematPurchase`;
    let request = { data: this.EncrdecrService.setEncr(formData) }
    return this.http.post<any>(DataUrl, request, headers);
  }

  GetSGBOrderBook(formData): Observable<any> {

    let DataUrl = `${this.ServerUrl}/api/SGBOrderBookReport/Details`;
    console.log(formData);
    const header = this.GetToken();
    const body = { data: this.EncrdecrService.setEncr(formData) };
    return this.http.post<any>(DataUrl, body, header).pipe();
    // return this.http.post<any>(DataUrl,formData,header).pipe();
  }
}
